import { Component, OnInit, inject, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AuthService } from '../auth';
import { TranslateService } from '@ngx-translate/core';

import { LoginService, SiteParams, UserData } from '../../login/login.service';

import { UiService } from '../ui.service';

declare var $: any;

@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html',
    styles: [``],
    standalone: false,
})
export class LayoutComponent implements OnInit {
    #authService = inject(AuthService);
    #loginService = inject(LoginService);
    #translate = inject(TranslateService);
    #uiService = inject(UiService);
    #destroyRef = inject(DestroyRef);

    isAuth: boolean = false;
    version: string = 'LOCAL';

    langs = [
        { id: 'en', name: 'English' },
        { id: 'it', name: 'Italian' },
    ];
    siteParams: SiteParams;
    userData: UserData;

    currentLang: string;

    ngOnInit() {
        this.isAuth = this.#authService.isAuth();

        this.currentLang = this.langs.find((l) => l.id == this.#translate.currentLang).name;

        this.#translate.onLangChange
            .pipe(takeUntilDestroyed(this.#destroyRef))
            .subscribe((ev) => (this.currentLang = this.langs.find((l) => l.id == ev.lang).name));

        this.#loginService
            .getSiteParams()
            .pipe(takeUntilDestroyed(this.#destroyRef))
            .subscribe({
                next: (sp) => (this.siteParams = sp),
                error: (err) => {
                    this.logout();
                    console.log(err);
                },
            });

        this.#loginService.UserData.pipe(takeUntilDestroyed(this.#destroyRef)).subscribe({
            next: (ud: UserData) => (this.userData = ud),
            error: (err) => console.log(err),
        });

        $(document).ready(function () {
            $('.computer.only .dropdown.item').popup({
                inline: true,
                hoverable: true,
                position: 'bottom left',
                delay: {
                    show: 300,
                    hide: 800,
                },
            });
            $('.ui.dropdown').dropdown();
        });
        this.#uiService
            .getVersion()
            .then((version) => {
                this.version = (version as string).replace('Staging-', '');
                console.log('Version: ', this.version);
            })
            .catch(() => {});
    }

    changeLanguage(id: string) {
        this.#translate.use(id);
        return false;
    }

    logout() {
        this.#authService.logout();
    }
}
